<template>
  <div class="notifications" v-if="notifications">
    <template v-for="(item, index) in notifications">
      <alert-box
        :type="item.type"
        :message="item.message"
        @close="removeNotification(index)"
        :key="index"
      />
    </template>
  </div>
</template>

<script>
import AlertBox from './AlertBox';

export default {
  components: {
    AlertBox,
  },
  created() {
    this.$alert.setContainer(this);
  },
  data() {
    return {
      notifications: [],
    };
  },
  methods: {
    addNotification(notification, type) {
      this.notifications.push({
        message: notification,
        type,
      });
    },
    removeNotification(index) {
      this.notifications.splice(index, 1);
    },
  },
};
</script>
